import { render } from "./RoofingPage.vue?vue&type=template&id=6aad431e&scoped=true"
import script from "./RoofingPage.vue?vue&type=script&lang=js"
export * from "./RoofingPage.vue?vue&type=script&lang=js"

import "./RoofingPage.vue?vue&type=style&index=0&id=6aad431e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aad431e"]])

export default __exports__